import { createSafeContext } from '@/util';

import type { VSliderContextValue } from './type';

export const VSliderContext = createSafeContext<VSliderContextValue<any>>(
  null,
  'VSliderContext',
);
